import React from 'react';

import { SVGComponentProps } from './svg.types';

const UserStorySVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: SVGComponentProps) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.888916" width="20" height="20" rx="6" fill="#15B9B0" />
      <g clipPath="url(#clip0_470_17643)">
        <path
          d="M12.8889 14.5V13.5C12.8889 12.9696 12.6782 12.4609 12.3031 12.0858C11.9281 11.7107 11.4193 11.5 10.8889 11.5H7.88892C7.35848 11.5 6.84978 11.7107 6.4747 12.0858C6.09963 12.4609 5.88892 12.9696 5.88892 13.5V14.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.38892 9.5C10.4935 9.5 11.3889 8.60457 11.3889 7.5C11.3889 6.39543 10.4935 5.5 9.38892 5.5C8.28435 5.5 7.38892 6.39543 7.38892 7.5C7.38892 8.60457 8.28435 9.5 9.38892 9.5Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3889 10.5C14.9412 10.5 15.3889 10.0523 15.3889 9.5C15.3889 8.94772 14.9412 8.5 14.3889 8.5C13.8366 8.5 13.3889 8.94772 13.3889 9.5C13.3889 10.0523 13.8366 10.5 14.3889 10.5Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M14.3889 8V8.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.3889 10.5V11" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M15.6889 8.75L15.2539 9"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5239 10L13.0889 10.25"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6889 10.25L15.2539 10"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5239 9L13.0889 8.75"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_470_17643">
          <rect width="12" height="12" fill="white" transform="translate(4.88892 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserStorySVG;
